import { ReturnOpportunityProductReadable } from '@crm/api'

import { getLineTotal } from './getLineTotal'

export const getProductsSummary = (
  products: ReturnOpportunityProductReadable[]
) => {
  const totalPrice = products.reduce(
    (acc, p) => acc + (Number(p.custom_price) || 0) * (Number(p.quantity) || 1),
    0
  )
  const totalDiscount = products.reduce(
    (acc, p) => acc + (Number(p.extra_discount) || 0),
    0
  )
  const totalAfterDiscount = products.reduce(
    (acc, p) => acc + getLineTotal(p),
    0
  )

  return {
    totalPrice,
    totalDiscount,
    totalAfterDiscount,
    getLineTotal
  }
}
